/**
 * Native-shell awareness for Edge Training.
 *
 * When the React app is loaded inside the Capacitor native shell (iOS/Android
 * store builds), `Capacitor.isNativePlatform()` returns true. In the regular
 * browser (desktop, PWA installed from Safari/Chrome, dev server) it returns
 * false. Use these helpers to fork UX politely — e.g. skip the install
 * prompt banner when we're already installed as a real app.
 *
 * Zero cost if @capacitor/core is not present (feature-detects window.Capacitor).
 */

export function isNativeApp() {
  try {
    const cap = globalThis.Capacitor;
    return typeof cap?.isNativePlatform === "function" && cap.isNativePlatform();
  } catch {
    return false;
  }
}

export function getNativePlatform() {
  try {
    const cap = globalThis.Capacitor;
    const p = cap?.getPlatform?.();
    if (p === "ios" || p === "android") return p;
  } catch { /* ignore */ }
  return "web";
}
